// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__22r0M","list":"BalanceDue_list__2WHnv","listRow":"BalanceDue_listRow__3VTeD","total":"BalanceDue_total__3SO7o"};